import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {forwardRef, useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {getReportData, getReportDefinition} from "../common/api/ReportApi";
import {CardContent, Chip, Link, NativeSelect} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import Loading from "../common/Loading";
import {formatCurrency, formatDateMask} from "../common/Utils";
import BootyPagination from "../common/bootyPagination";
import DataTable from "react-data-table-component";
import * as pagination from "../common/pagination";
import {useForm} from "react-hook-form";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {getCookie, setCookie} from "../common/appCookie";
import Switch from "@mui/material/Switch";
import {Col} from "react-bootstrap";
import moment from "moment/moment";
import Checkbox from "@mui/material/Checkbox";
import MDInput from "../../components/MDInput";
import {BarChart} from "@mui/x-charts/BarChart";
import FileSelector from "../calendarUI/FilterSelector";

export default function GenericReport({
                                        type,
                                        range,
                                        disableCalendar,
                                        all,
                                        defaultRange,
                                        defaultRangeStart,
                                        defaultRangeEnd
                                      }) {
  const widthFn = () => {
    let w = parseInt(window.innerWidth, 10) * .5;
    return parseInt(window.innerWidth, 10) * .5;
  }
  const [docWidth, setDocWidth] = useState(100);

  useEffect(() => {
    function handleWidthFn() {
      setDocWidth(widthFn());
    }

    window.addEventListener("resize", handleWidthFn);
    handleWidthFn();
    return () => window.removeEventListener("resize", handleWidthFn);
  }, []);

  const [reportName, setReportName] = useState('');
  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const [reportPeriod, setReportPeriod] = useState();
  const [reportData, setReportData] = useState();
  const [loading, setLoading] = useState(true);

  const [eventDate, setEventDate] = useState();
  const [eventEndDate, setEventEndDate] = useState();

  const _BootyPagination = {...BootyPagination};
  let {reportYear, reportMonth, reportEndYear, reportEndMonth, criteria} = useParams();

  const [pageNum, setPageNum] = useState(0);

  useEffect(() => {
    _BootyPagination.reportData = {...reportData};
  }, [reportData]);

  useEffect(() => {
    setEventDate(handleStartDate())
  }, []);

  const [reportDefinition, setReportDefinition] = useState(null);

  const handleStartDate = () => {
    let _d = new Date();
    if (reportYear) {
      _d.setFullYear(reportYear);
    }
    if (reportMonth) {
      let date = moment(reportMonth, "MMM").toDate();
      _d.setMonth(date.getMonth());
    }

    if (defaultRangeStart) {
      _d = moment().add(parseInt(defaultRangeStart, 10), 'days').toDate();
    }

    return _d;
  }

  const [showChartData, setShowChartData] = useState(false);
  useEffect(() => {
    setShowChartData(reportDefinition?.chartData && (type === 'checkin' || type === 'partyage' || type === 'discountcode'));
  }, [reportDefinition])

  const [chartData, setChartData] = useState();

  const formatChartData = (report) => {
    if (report?.pieChartData) {
      setChartData(report?.pieChartData);
    }
  }

  const [initLoad, setInitLoad] = useState(false);

  const getReportDataFn = (firstLoad, pageNum) => {
    let _eventDate;
    setLoading(true);
    if (eventDate) {
      _eventDate = eventDate;
    } else {
      _eventDate = handleStartDate()
    }
    let req = {
      startDate: _eventDate,
      criteria: criteria,
      all: all,
      startPage: pageNum
    }

    if (rangeReport) {
      let _endDate = eventEndDate;
      if (firstLoad && defaultRangeEnd) {
        _endDate = moment().add(parseInt(defaultRangeEnd, 10), 'days').toDate();
        setEventEndDate(_endDate);
      }
      if (!_endDate) {
        _endDate = _eventDate;
        setEventEndDate(_endDate);
      }
      req.endDate = _endDate;
    }

    getReportData(type, req).then((r) => {
      setReportData(r);
      formatChartData(r);
      setInitLoad(true);
      setLoading(false);
    });
  }


  const getDefaultSortAsc = () => {
    if (reportDefinition?.serverSide) {
      return false;
    }
    let isDefaultSortAsc = getCookie(reportDefinition?.name.replaceAll(' ', '_') + 'REPORT_SORT_DIR') === 'desc' ? false : true;
    return isDefaultSortAsc;
  }
  const getDefaultSortFieldId = () => {
    let sort = getCookie(reportDefinition?.name.replaceAll(' ', '_') + 'REPORT_SORT') || 1;
    return sort;
  }

  useEffect(() => {
    if (!initLoad) {
      return;
    }
    getReportDataFn(false);
  }, [criteria])

  const exportCsv = () => {
    let _rows = {...reportData};
    let d = _rows?.reportItems;
    let filename = reportDefinition?.name + '-' + formatDateMask(new Date(), 'MM-DD-YYYY-hh-mm-ss') + '.csv';

    let fields = Object.keys(d[0])
    let replacer = function (key, value) {
      return value === null ? '' : value
    }
    let csv = d.map(function (row) {
      return fields.map(function (fieldName) {
        return JSON.stringify(row[fieldName], replacer)
      }).join(',')
    });

    for (let f in fields) {
      let fieldName = fields[f].charAt(0).toUpperCase() + fields[f].slice(1);
      fieldName = fieldName.split(/(?=[A-Z])/).join(' ');
      fields[f] = fieldName;
    }
    csv.unshift(fields.join(',')) // add header column
    csv = csv.join('\r\n');
    let blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const composeEmail = () => {
    let ids = []
    for (const j in selectedRows) {
      ids.push(selectedRows[j].guid);
    }
    if (ids.length === 1) {
      navigate('/email/client/' + ids[0], {replace: false});
    } else {
      navigate('/email/clients/' + ids.join(','), {replace: false});
    }
  }

  const ActionCheckbox = React.forwardRef(({row, onClick}, ref) => {
    return (
      <>
        <div className="form-check mt-1" style={{backgroundColor: ''}}>
          {row && <Checkbox
            type="checkbox"
            style={{height: '20px', width: '20px'}}
            ref={ref}
            onClick={() => {
              row.selected = !row.selected;
            }}
          />}
        </div>
      </>
    )
  })

  const calculateTotal = (field) => {
    let total = 0;
    reportData?.reportItems?.forEach((item, idx) => {
      let cost = parseFloat(item[field]);
      if (cost && cost > 0) {
        total += cost;
      }
    });
    return total;
  }

  useEffect(() => {
      getReportDefinition(type).then((r) => {

        setReportName(r.name);

        let _cols = [];
        let idx = 0;
        for (let j in r.columns) {
          let col = r.columns[j];
          ++idx;
          col.key = idx;
          let selector = r.columns[j].selector;
          col.selector = row => row[selector];
          col.omit = r.columns[j].hidden;
          col.selected = false;

          if (col.checkbox) {
            col.cell = row => {
              return (
                <ActionCheckbox row={row}/>
              )
            }
          }
          if (col.date) {
            col.cell = formatDateMask(col[selector], col.dateMask)
          }
          if (col.date) {
            col.cell = row => {
              if (!row[selector]) {
                return '';
              }
              return (formatDateMask(row[selector], col.dateMask))
            }
          }

          if (col.sortFn) {
            col.sortFunction = (row1, row2) => {
              if (col.sortFn?.numeric) {
                return parseInt(row1[col.sortFn.columnName], 10) - parseInt(row2[col.sortFn.columnName], 10);
              } else {
                let _r1 = row1[col.sortFn.columnName];
                let _r2 = row2[col.sortFn.columnName]
                return _r1.localeCompare(_r2);
              }
            }
          }
          if (col.numeric) {
            col.sortFunction = (row1, row2) => {
              return parseInt(row1[selector], 10) - parseInt(row2[selector], 10)
            }
          }
          if (col.currency && col.sortable) {
            col.right = true;
            col.sortFunction = (row1, row2) => {
              return parseFloat(row1[selector]) - parseFloat(row2[selector])
            }
            col.cell = row => {
              if (!row[selector]) {
                return '';
              }
              return (formatCurrency(row[selector]))
            }
          }
          if (col.alignRight) {
            col.right = true;
          }

          if (col.linkFn) {
            col.cell = row => {
              if (col.linkFn.linkKey === 'getTagFn') {
                let links = [];
                row[selector].split(',').forEach((k, v) => {
                  return (
                    links.push(<Chip key={v} clickable
                                     variant="outlined"
                                     component="a"
                                     color="secondary" label={k.trim()}
                                     className="link"
                                     href={col.linkFn.linkTo + k.trim()}
                    />)
                  )
                });

                return <MDBox>{links.map((link, idx) => {
                  return <span key={idx}>{link}</span>
                })}</MDBox>
              } else {
                return (<Link className="link"
                              href={col.linkFn.linkTo + row[col.linkFn?.linkKey]}>
                  {row[selector]}
                </Link>)
              }
            }
          }

          _cols.push(col)
        }
        setColumns(_cols);

        let _def = {...r};
        _def.columns = _cols;
        setReportDefinition(_def);

        getReportDataFn(true);

        return;
      });
    }, []
  );

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);
  const handleRowSelected = React.useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const resultsFiltered = (items) => {
    if (reportFilter?.length > 0) {
      let _items = [];
      for (const item in items) {
        let key = parseInt(items[item][reportDefinition?.filterType], 10);
        for (const f in reportFilter) {
          if (parseInt(reportFilter[f], 10) === key) {
            _items.push(items[item]);
          }
        }
      }
      return _items;
    }

    if (!filterText || filterText.length === 0) {
      return items;
    }
    let _items = [];
    for (const item in items) {
      let keys = [];
      for (const key in items[item]) {
        keys.push(key);
      }

      let inSearch = false;
      for (const k in keys) {
        let crit = items[item]?.[keys[k]]?.toLowerCase();
        if (crit) {
          let match = crit.match(filterText.toLowerCase());
          if (match && match.length > 0) {
            inSearch = true;
          }
        }
      }
      if (inSearch) {
        _items.push(items[item])
      }
    }
    return _items;
  }

  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [columns, setColumns] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);

  const handlePageChange = (selector, page) => {
    setStartPage(selector);
    if (reportDefinition?.serverSide) {
      getReportDataFn(false, selector - 1);
    }
  };

  const [render, setRender] = useState(1);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);
  const [reportFilter, setReportFilter] = useState([]);

  const handleSort = (column, sortDirection) => {
    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie(reportDefinition?.name.replaceAll(' ', '_') + 'REPORT_SORT', column.id);
    setCookie(reportDefinition?.name.replaceAll(' ', '_') + 'REPORT_SORT_DIR', sortDirection);
    setRender(render + 1);
  };

  const [reportEndPeriod, setReportEndPeriod] = useState();
  const [rangeReport, setRangeReport] = useState(defaultRange || false);

  const toggleReportRange = () => {
    setRangeReport(!rangeReport)
    setEventEndDate(eventDate);
  }

  const updateEventDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventDate(_d);
    setReportPeriod(_period);
  }

  const updateEventEndDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventEndDate(_d);
    setReportEndPeriod(_period);
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <span className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <MDTypography variant="h5" color="secondary" fontWeight="light" sx={{
        display: 'inline-block'
      }}>
        <Icon sx={{
          marginTop: '2px',
        }}>event</Icon>Report Date - {formatDateMask(eventDate, 'MMMM yyyy')}
      </MDTypography>
    </span>
  ));

  const valueFormatter = (value) => {
    return formatCurrency(value);
  };

  const [filterText, setFilterText] = useState('');

  function defaultSelectedCriteria(filterQuery) {
    let defaultSelected = filterQuery[0].id;
    filterQuery.map((c) => {
      if (criteria === c.query) {
        defaultSelected = c.id
      }
    });
    return defaultSelected;
  }

  return (

    <DashboardLayout>

      <Meta pageTitle={`${reportName}`}/>

      <ContextSearchNavbar title={`${reportName}`}/>

      <MDBox py={3}>
        <MDBox mb={3}>

          {!reportData && <Loading/>}
          {reportData && <Grid container spacing={1} mb={2}>
            {disableCalendar ? <></> :
              <>
                <Grid item xs={12}>
                  <DesktopDatePicker
                    sx={{
                      '& .MuiInputBase-root': {
                        borderRadius: '4px 0 0 4px'
                      }
                    }}
                    closeOnSelect={false}
                    views={reportDefinition?.calendarViews}
                    slotProps={{
                      actionBar: {
                        actions: ['today', 'accept'],
                      },
                    }}
                    value={dayjs(eventDate)}
                    onChange={(e) => {
                      updateEventDates(e?.$d || null);
                    }}
                  />
                  {rangeReport &&
                    <DesktopDatePicker
                      sx={{
                        '& .MuiInputBase-root': {
                          borderRadius: '4px 0 0 4px'
                        }
                      }}
                      closeOnSelect={false}
                      views={reportDefinition?.calendarViews}
                      slotProps={{
                        actionBar: {
                          actions: ['today', 'accept'],
                        },
                      }}
                      value={dayjs(eventEndDate)}
                      onChange={(e) => {
                        updateEventEndDates(e?.$d || null);
                      }}
                    />}
                  <MDButton
                    sx={{
                      borderRadius: '0 4px 4px 0',
                      height: '100%'
                    }}
                    color="info"
                    onClick={() => {
                      getReportDataFn(false);
                    }}
                  >Go</MDButton>
                </Grid>
                <Grid item xs={12}>
                  {range && <Col xs={12}>
                    <label
                      htmlFor="rangeReport">
                      Date Range
                      <Switch
                        name={'rangeReport'}
                        id={'rangeReport'}
                        checked={rangeReport}
                        style={{marginRight: '5px'}}
                        onChange={toggleReportRange}
                      /> </label>
                  </Col>}
                </Grid>
              </>
            }
            {showChartData &&
              <>{chartData && <Grid item sm={8} xs={12}>
                <Card>
                  <CardContent sx={{
                    height: '320px'
                  }}>
                    <MDTypography variant="h5" fontWeight={"light"}>
                      {type === 'checkin' && 'Hourly Check-Ins'}
                      {type === 'partyage' && 'Birthday Party Age Report'}
                      &nbsp;
                    </MDTypography>
                    {chartData && <BarChart
                      tooltip={{trigger: 'item'}}
                      grid={{vertical: true, horizontal: true}}
                      dataset={chartData}

                      xAxis={[
                        {
                          scaleType: 'band',
                          dataKey: 'label',
                          colorMap: {
                            type: 'ordinal',
                            colors: ['#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e']
                          }
                        }
                      ]}
                      series={[{dataKey: 'value'}]}
                      width={docWidth}
                      height={300}
                    />}
                  </CardContent>
                </Card>
              </Grid>}</>
            }
            {Object.entries(reportData?.reportTotals)?.length > 0 && <>
              <Grid container spacing={1} mt={1} justifyContent={'right'} style={{
                marginTop: (range ? '-100px' : '-60px')
              }}>
                <Grid item sm={6}>
                  <Card>
                    <CardContent>
                      {Object.entries(reportData?.reportTotals).sort(([idA], [idB]) => idA - idB).map(([id, value]) => (
                        <div key={id}>
                          <MDTypography variant="h5" color="secondary"
                                        className={'mt-3'}
                                        fontWeight="regular">
                            {Object.entries(value).map(([id, _value]) => (
                              <span key={id}>
                                <strong>{id}</strong>: <span className={'pull-right'}>{formatCurrency(_value)}</span>
                              </span>
                            ))}
                          </MDTypography>
                        </div>
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

            </>}
            {reportDefinition?.calculateTotal &&
              <Grid container spacing={1} mt={1} justifyContent={'right'} style={{
                marginTop: (range ? '-100px' : '-60px')
              }}>
                <Grid item sm={showChartData ? 4 : 6}>
                  <Card>
                    <CardContent>
                      <MDTypography variant="h5" color="secondary"
                                    className={'mt-3'}
                                    fontWeight="regular">
                        Total: {formatCurrency(calculateTotal(reportDefinition?.totalField))}
                      </MDTypography>

                      {chartData && <table className={'table table-striped'}>
                        <thead>
                        <tr>
                          <th>{reportDefinition?.totalLabel}</th>
                          {reportDefinition?.usageField &&
                            <th className={'text-right'}>{reportDefinition?.usageField}</th>
                          }

                          <th className={'text-right'}>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        {chartData?.sort((a, b) => b.value - a.value)?.map((a, b) => {
                          return (
                            <tr key={b}>
                              <td>{a.label}</td>
                              {reportDefinition?.usageField &&
                                <td className={'text-right'}>{a?.usage}</td>
                              }
                              <td className={'text-right'}>{formatCurrency(a.value)}</td>
                            </tr>
                          )
                        })
                        }
                        </tbody>
                      </table>}

                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            }

            <Card sx={{
              marginTop: '15px',
              width: '100%'
            }}>
              <CardContent>

                {reportDefinition && <>

                  <DataTable
                    striped
                    subHeader
                    subHeaderComponent={<div style={{
                      display: 'block',
                      width: '100%'
                    }}>
                      {reportDefinition?.includeFilter && <>
                        {!reportDefinition?.filterType && <>
                          <MDInput type={"text"}
                                   onChange={(e) => {
                                     setFilterText(e.target.value);
                                   }}
                                   style={{
                                     width: '40%',
                                     float: 'left',
                                     marginLeft: '-20px'
                                   }}
                                   placeholder={"Filter Results"}/>
                        </>}
                        {reportDefinition?.filterType?.length > 0 && <div style={{
                          width: '30%',
                          float: 'left',
                          marginLeft: '-20px'
                        }}>
                          <FileSelector
                            types={reportDefinition?.filters}
                            typeFilter={reportFilter}
                            filterLabel={reportDefinition?.filterLabel}
                            setFilter={(filters) => {
                              setReportFilter(filters)
                            }}
                            height={'420px'}
                            width={'100%'}
                          />
                        </div>}

                        {reportDefinition?.filterQuery?.length > 0 && <div style={{
                          width: '30%',
                          float: 'left',
                          marginLeft: '20px',
                          marginTop: '-18px'
                        }}>
                          <label className="native-label"
                                 htmlFor="filterQuery">{reportDefinition?.filterQueryLabel}</label>
                          <NativeSelect
                            variant="outlined"
                            defaultValue={defaultSelectedCriteria(reportDefinition?.filterQuery)}
                            onChange={(e) => {
                              for (const k in reportDefinition?.filterQuery) {
                                if (parseInt(e.target.value, 10) === parseInt(reportDefinition?.filterQuery[k].id, 10)) {
                                  navigate(`/${type}/report/${reportDefinition?.filterQuery[k].query}`)
                                }
                              }
                            }}
                            id={'filterQuery'} name={'filterQuery'} className={'form-control'}>
                            {
                              reportDefinition?.filterQuery.map((c) =>
                                <option value={c.id} key={c.id}>
                                  {c.name}
                                </option>)
                            }
                          </NativeSelect>
                        </div>}

                      </>}

                      <MDButton
                        color="primary"
                        size="small"
                        className="pull-right mx-1"
                        style={{
                          marginRight: '-20px',
                        }}
                        onClick={() => {
                          exportCsv()
                        }}>Export</MDButton>
                      {reportDefinition?.emailEnabled &&
                        <MDButton
                          className="pull-right mx-1"
                          color="secondary"
                          size="small"
                          disabled={!selectedRows || selectedRows?.length === 0}
                          onClick={() => {
                            composeEmail()
                          }}><span className="fa fa-email"></span>&nbsp;Compose Email</MDButton>
                      }
                    </div>}
                    noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                                   fontWeight={'light'}>No
                      Data Found</MDTypography>}
                    columns={columns}
                    keyField={'id'}
                    data={resultsFiltered(reportData?.reportItems)}
                    onSort={handleSort}
                    highlightOnHover
                    paginationServer={reportDefinition?.serverSide}
                    selectableRows={reportDefinition?.emailEnabled}
                    selectableRowsVisibleOnly
                    progressComponent={<Loading/>}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggledClearRows}
                    pagination={reportDefinition?.emailEnabled}
                    paginationPerPage={reportDefinition?.pageSize || 50}
                    paginationTotalRows={reportDefinition?.serverSide ? reportData?.total : reportData?.reportItems?.length}
                    onChangePage={handlePageChange}
                    progressPending={!reportData || loading}
                    defaultSortFieldId={getDefaultSortFieldId()}
                    defaultSortAsc={getDefaultSortAsc()}
                    paginationComponentOptions={PaginationOptions}
                  />
                </>
                }
              </CardContent>
            </Card>

          </Grid>
          }
        </MDBox>
      </MDBox>
      <Footer mt={5}/>
    </DashboardLayout>
  );
}